"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildChildLogger = exports.setRootLogger = exports.rootLogger = void 0;
const pino_1 = __importDefault(require("pino"));
const shared_utils_iso_1 = require("@wranggle/shared-utils-iso");
let _rootLogger;
function rootLogger() {
    if (!_rootLogger) {
        setRootLogger(pino_1.default({
            browser: {
                asObject: true
            },
            level: 'info',
        }));
    }
    return _rootLogger;
}
exports.rootLogger = rootLogger;
function setRootLogger(logger) {
    _rootLogger = logger;
    shared_utils_iso_1.setLoggerForSharedIsoUtilsLib(logger);
}
exports.setRootLogger = setRootLogger;
function buildChildLogger(fields, parentLogger) {
    return (parentLogger || rootLogger()).child(fields);
}
exports.buildChildLogger = buildChildLogger;
//# sourceMappingURL=root-logger.js.map